// extracted by mini-css-extract-plugin
export var container = "_oa-0";
export var dotAnimation = "_oa-2";
export var dotsLoading = "_oa-1";